import { useCallback } from 'react'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'
import ApiService from 'services/ApiService'

const InteractorMasterDistrictView = () => {
  const districtView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-district/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          back: true,
        })
      }
      loading(false)
    })
  }, [])

  return { districtView }
}

export default InteractorMasterDistrictView
